import { Extension } from '@codemirror/state';
import { EditorView } from '@codemirror/view';

/**
 * Code Mirror 6 extension to replace each Tab characters in the pasted text
 * by some ident string (typically with a number of spaces).
 *
 * @param identUnit a string to replace each `\t` character in the pasted text
 */
export function pasteTabsAsSpaces(identUnit: string): Extension {
    return EditorView.domEventHandlers({
        paste: (e, view) => {
            e.preventDefault();
            const pastedCode = e.clipboardData?.getData('text/plain');
            if (pastedCode) {
                const processedCode = pastedCode.replace(/\r\n/gm, '\n').replace(/\t/gm, identUnit);
                const { from, to } = view.state.selection.main;
                view.dispatch(
                    view.state.update({
                        userEvent: 'input.paste',
                        changes: { from, to, insert: processedCode },
                        selection: { anchor: from + processedCode.length },
                    })
                );
            }
        },
    });
}
